import React from "react";
import { Route, Routes } from "react-router-dom";
import GovernanceDashboard from "../Pages/Governance/Dashboard/Dashboard";
import BoardStructureForm from "../Pages/GovernanceDashboard/DataEntry/BoardStructure";
import ExcutiveCompensation from "../Pages/GovernanceDashboard/DataEntry/BExecutive";
import RiskManagementForm from "../Pages/GovernanceDashboard/DataEntry/CRiskManagement";
import ComplianceForm from "../Pages/GovernanceDashboard/DataEntry/DComplianceEthics";
import ShareholderRights from "../Pages/GovernanceDashboard/DataEntry/EShareholder";
import TransparancyDisclosure from "../Pages/GovernanceDashboard/DataEntry/FTransparancy";
import PolicyForm from "../Pages/GovernanceDashboard/DataEntry/GPolicyForm";
import GovernaceData from "../Pages/GovernanceDashboard/DataEntry/Data";

export const GovernanceRoutes = [
  { path: "/governance/dashboard", element: <GovernanceDashboard /> },
  { path: "/governance/data", element: <GovernaceData /> },
  {
    path: "/governance/data/board-structure/:id",
    element: <BoardStructureForm />,
  },
  {
    // Backward-compatible correct spelling
    path: "/governance/data/executive-compensation/:id",
    element: <ExcutiveCompensation />,
  },
  {
    path: "/governance/data/risk-management/:id",
    element: <RiskManagementForm />,
  },
  {
    path: "/governance/data/compliance-ethics/:id",
    element: <ComplianceForm />,
  },
  {
    path: "/governance/data/shareholder-rights/:id",
    element: <ShareholderRights />,
  },
  {
    path: "/governance/data/transparancy-disclosure/:id",
    element: <TransparancyDisclosure />,
  },
  { path: "/governance/data/policy-form/:id", element: <PolicyForm /> },
];
